import React, { useState } from "react";
import "./authShell.css";

// Split-screen frame for the pre-login screens (organisation identifier,
// login, forgot/reset password, sign-up verification). Layout only - each
// screen keeps its own form, state and API calls.
type AuthShellProps = {
  logo?: string | null;
  orgName?: string | null;
  topRight?: React.ReactNode;
  children: React.ReactNode;
};

const usableLogo = (logo?: string | null) =>
  logo && logo !== "null" && logo !== "undefined" ? logo : "";

export default function AuthShell({ logo, orgName, topRight, children }: AuthShellProps) {
  const [logoFailed, setLogoFailed] = useState(false);
  const logoSrc = usableLogo(logo);
  const name = orgName && orgName !== "null" ? orgName : "";
  const initial = (name || "A").trim().charAt(0).toUpperCase();

  const mark = logoSrc && !logoFailed ? (
    <img className="auth-logo" src={logoSrc} alt={name || "Logo"} onError={() => setLogoFailed(true)} />
  ) : (
    <div className="auth-logo-mark" aria-hidden="true">{initial}</div>
  );

  return (
    <div className="auth-shell">
      <aside className="auth-brand">
        <div className="auth-brand-top">{mark}</div>
        <div className="auth-brand-copy">
          <h1>{name ? `${name} Admin` : "Admin Panel"}</h1>
          <p>Manage your stores, orders and deliveries in one place.</p>
        </div>
        <div className="auth-brand-foot">© {new Date().getFullYear()} {name || "Admin Panel"}</div>
      </aside>
      <main className="auth-main">
        {topRight ? <div className="auth-topbar">{topRight}</div> : null}
        <div className="auth-center">
          <div className="auth-mobile-mark">{mark}</div>
          <div className="auth-card">{children}</div>
        </div>
      </main>
    </div>
  );
}
